import {
  DefaultUploadManager,
  UploadManager,
} from "@/modules/audio-recording/upload/upload-manager";
import {
  WebAudioArtifactRef,
  WebAudioArtifactService,
} from "@/modules/audio-recording/web-artifacts";
import {
  AudioUploadTransport,
  AudioUploadTransportInput,
  UploadTransportResult,
} from "@/store/audio/uploading/audio-uploading.types";

type WebAudioUploadTransportConfig = {
  createUploadManager?: () => UploadManager;
  artifacts: WebAudioArtifactService;
};

export class WebAudioUploadTransport implements AudioUploadTransport<WebAudioArtifactRef> {
  private readonly createUploadManager: () => UploadManager;
  private readonly artifacts: WebAudioArtifactService;

  constructor({ createUploadManager, artifacts }: WebAudioUploadTransportConfig) {
    this.createUploadManager =
      createUploadManager ??
      (() =>
        new DefaultUploadManager({
          minUploadDurationMs: 1000,
          progressUpdateIntervalMs: 50,
        }));
    this.artifacts = artifacts;
  }

  async upload({
    source,
    uploadMeta,
    forceRestart,
    onProgress,
  }: AudioUploadTransportInput<WebAudioArtifactRef>): Promise<UploadTransportResult> {
    const blob = await this.artifacts.readAudioArtifactBlob({
      artifactRef: source,
    });

    const uploadManager = this.createUploadManager();

    return uploadManager.start(blob, uploadMeta, {
      onProgress: progressPercent => {
        onProgress({ progressPercent });
      },
      forceRestart,
    });
  }
}
